/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMsIcon16Regular = forwardRef('ShapeCircleMsIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8Zm5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" })));
});
